import styles from './NoFriends.module.css'
import CopyButton from "../CopyButton/CopyButton.tsx";

const NoFriends = () => {

    const copyInviteLink = () => {
        const userId: number = window.Telegram?.WebApp.initDataUnsafe.user.id
        window.Telegram?.WebApp.openTelegramLink(`https://t.me/share/url?url=https://t.me/dreamcoin_bot?start=${userId}`)
    }

    return (
        <div className={styles.referralsSection}>
            <h2 className={styles.referralsTitle}>Рефералы</h2>
            <p className={styles.referralsSubtitle}>Ты еще не пригласил ни одного друга</p>

            <div className={styles.steps}>
                <div className={styles.step}>
                    <div className={styles.stepIcon}>
                        <div className={styles.stepIcon__img}></div>
                    </div>
                    <p className={styles.stepText}>Пригласи друга в игру</p>
                </div>

                <div className={styles.step}>
                    <div className={styles.stepIcon}>
                        <div className={styles.stepIcon__img}></div>
                    </div>
                    <p className={styles.stepText}>Дождись пока он заработает свои бисткоины</p>
                </div>

                <div className={styles.step}>
                    <div className={styles.stepIcon}>
                        <div className={styles.stepIcon__img}></div>
                    </div>
                    <p className={styles.stepText}>Получи 10% от его дохода на свой игровой баланс</p>
                </div>
                <div className={styles.inviteBtn}>
                    <button onClick={copyInviteLink}>Пригласить</button>
                </div>
            </div>
            <CopyButton/>
        </div>
    )
}

export default NoFriends